import {useTranslation} from 'react-i18next';

import {
  AppButton,
  AppButtonVariant,
  ButtonContainer,
} from '@/app/shared-components';
import InputTextField from '@/app/shared-components/InputTextField/InputTextField';
import PasswordTextField from '@/app/shared-components/PasswordTextField/PasswordTextField';
import VerifyPassword from '@/app/shared-components/VerifyPassword/VerifyPassword';

import {AuthenticationWrapper} from '../../components/AuthenticationWrapper';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

import './styles';

const ChangePasswordContent = () => {
  const {t} = useTranslation();
  const {
    isMobile,
    email,
    newPassword,
    confirmNewPassword,
    verifyList,
    navigate,
    setEmail,
    setNewPassword,
    setConfirmNewPassword,
    handlePressChangePassword,
    setIsVerify,
    setEmailError,
    disabledButton,
  } = useViewModelProvider();

  return (
    <AuthenticationWrapper
      title={t('change_password_page.title')}
      showRightPanel={false}
      showBrands={false}
      onBack={() => {
        navigate('/authentication/password/forgot');
      }}>
      <form className="change-password-card">
        <InputTextField
          id="change-password-email-input"
          autoComplete="email"
          type="email"
          label={t('change_password_page.email_input')}
          placeholder={t('change_password_page.email_input')}
          value={email}
          setValue={setEmail}
          autofocus
          onErrorChange={setEmailError}
        />

        <section
          className="password-container"
          style={{gap: 16}}>
          <PasswordTextField
            label={t('change_password_page.password_input')}
            password={newPassword}
            setPassword={setNewPassword}
            autocomplete="new-password"
            id="new-password"
          />

          {isMobile && newPassword && (
            <VerifyPassword
              key="verify-password-mobile"
              newPassword={newPassword}
              confirmPassword={confirmNewPassword}
              verifyList={verifyList}
              setVerify={setIsVerify}
            />
          )}

          <PasswordTextField
            label={t('change_password_page.confirm_password_input')}
            password={confirmNewPassword}
            setPassword={setConfirmNewPassword}
            autocomplete="new-password"
            id="confirm-new-password"
          />
        </section>

        {!isMobile && newPassword && (
          <VerifyPassword
            key="verify-password-desktop"
            newPassword={newPassword}
            confirmPassword={confirmNewPassword}
            verifyList={verifyList}
            setVerify={setIsVerify}
          />
        )}
        <ButtonContainer sticky>
          <AppButton
            id="change-password-submit-button"
            label={t('change_password_page.change_password_button')}
            onClick={handlePressChangePassword}
            variant={AppButtonVariant.onPrimary}
            disabled={disabledButton}
          />
        </ButtonContainer>
      </form>
    </AuthenticationWrapper>
  );
};

const ChangePasswordPage = () => (
  <ViewModelProvider>
    <ChangePasswordContent />
  </ViewModelProvider>
);

export default ChangePasswordPage;
